const JANUARY = 1;
const FEBRUARY = 2;
const MARCH = 3;
const MAY = 5;
const JUNE = 6;
const AUGUST = 8;
const SEPTEMBER = 9;
const NOVEMBER = 11;
const DECEMBER = 12;

function toTwoDigitYear(year: number): string {
  const lastTwo = -2;
  return String(year).slice(lastTwo);
}

export function calculateDealCode(date: Date): string {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;

  if (month === JANUARY || month === FEBRUARY) {
    const yearString = `${toTwoDigitYear(year - 1)}/${toTwoDigitYear(year)}`;
    return `Winter${yearString}`;
  }

  if (month >= MARCH && month <= MAY) {
    return `Spring${year}`;
  }

  if (month >= JUNE && month <= AUGUST) {
    return `Summer${year}`;
  }

  if (month >= SEPTEMBER && month <= NOVEMBER) {
    return `Autumn${year}`;
  }

  if (month === DECEMBER) {
    const yearString = `${toTwoDigitYear(year)}/${toTwoDigitYear(year + 1)}`;
    return `Winter${yearString}`;
  }

  throw new Error(
    `Impossible case! Invalid month value: ${month}. dealCode.ts > calculateDealCode`
  );
}
